import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e2) {
      setErr(apiError(e2, "Login failed"));
    } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-kys-ink px-4">
      <div className="w-full max-w-sm">
        <Link to="/" className="mb-8 block text-center font-serif text-4xl text-white">Kys Boutique</Link>
        <form onSubmit={submit} className="rounded-lg bg-white p-7 shadow-2xl">
          <div className="mb-5 flex items-center gap-2">
            <Lock className="h-5 w-5 text-kys-accent" />
            <h1 className="font-serif text-2xl text-kys-ink">Owner Login</h1>
          </div>
          {err && <p data-testid="login-error" className="mb-3 rounded bg-red-50 px-3 py-2 text-sm text-red-600">{err}</p>}
          <label className="mb-1 block text-xs font-medium text-kys-charcoal">Email</label>
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="mb-4 w-full rounded border border-kys-blush-border px-3 py-2.5 text-sm focus:border-kys-accent focus:outline-none" />
          <label className="mb-1 block text-xs font-medium text-kys-charcoal">Password</label>
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="mb-5 w-full rounded border border-kys-blush-border px-3 py-2.5 text-sm focus:border-kys-accent focus:outline-none" />
          <button data-testid="login-submit" disabled={busy}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-kys-ink py-3 text-sm font-semibold text-white transition hover:bg-kys-accent disabled:opacity-60">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
